import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PubNubProvider } from "pubnub-react";
import PubNub from "pubnub";
import Layout from "./layout/Layout";
import SettingsHub from "./pages/SettingsHub/SettingsHub";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Vendors from "./pages/Vendors/Vendors";
import AddVendor from "./pages/Vendors/AddVendor";
import VendorViewProfile from "./pages/Vendors/ViewProfile";
import Users from "./pages/Users/Users";
import UserViewProfile from "./pages/Users/ViewProfile";
import Doctors from "./pages/Doctors/Doctors";
import AddDoctor from "./pages/Doctors/AddDoctor";
import CreateAvailability from "./pages/Doctors/CreateAvailability";
import DoctorAvailability from "./pages/Doctors/DoctorAvailability";
import UserDoctorAvailability from "./pages/Users/DoctorAvailability";
import ViewProfile from "./pages/Doctors/ViewProfile";
import DoctorProfile from "./pages/Doctors/DoctorProfile";
import Support from "./pages/Support/Support";
import AddUser from "./pages/Users/AddUser";
import Revenue from "./pages/Revenue/Revenue";
import ForgotPassword from "./pages/auth/ForgotPassword";
import NotFound from "./pages/NotFound";
import AccessDenied from "./pages/AccessDenied";
import ProtectedRoute from "./components/ProtectedRoute";
import ChatApp from "./pages/chat/ChatApp";
import * as apicall from "./components/Apicall";
import {
  pub_nub_publishKey,
  pub_nub_subscribeKey,
  pub_nub_uuid,
  pub_nub_publishKey_admin,
  pub_nub_subscribeKey_admin,
  pub_nub_uuid_admin,
  admin_role_id
} from "./constants/Constants";
import Reports from "./pages/Reports/Reports";
import ImpersonationProvider from "./components/context/ImpersonationProvider";

import { PrimeReactProvider } from "primereact/api";
import Bookings from "./pages/Vendor_bookings/BookingStepper";
import Checkout from "./pages/Vendor_bookings/Checkout";
import Estimations from "./pages/Vendor_estimations/Estimations";
import EstimationForm from "./pages/Vendor_estimations/EstimationForm";
import EstimationView from "./pages/Vendor_estimations/EstimationView";
import Payments from "./pages/Vendor_bookings/Payments";
import Customers from "./pages/Customers/Customers";
import CustomerProfile from "./pages/Customers/CustomerProfile";
import CompanyProfile from "./pages/Customers/CompanyProfile";
import AddItems from "./pages/Vendor_bookings/AddItems";
import AddOfferings from "./pages/Vendor_bookings/AdminSetup";
import NewDashboard from "./pages/Dashboard/NewDashboard";
import Providers from "./pages/Providers/Providers";
import MyTasks from "./pages/Tasks/MyTasks";
import AddProviderGate from "./pages/Providers/AddProviderGate";
import ProviderAvailability from "./pages/Providers/ProviderAvailability";
import ProviderProfile from "./pages/Providers/ProviderProfile";
import NewDashboard1 from "./pages/Dashboard/NewDashboard1";
import SportsDashboard from "./pages/Dashboard/SportsDashboard";
import DashboardDetailed from "./pages/Dashboard/DashboardDetailed";
import CalendarPage from "./pages/Dashboard/CalendarPage";
import ProfileSetup from "./pages/auth/ProfileSetup";
import Setup from "./pages/Dashboard/Setup";
import PricingPage from "./pages/Pricing/Pricing";
import CustomerBooking from "./pages/Vendor_bookings/CustomerBooking";
import BidRequests from "./pages/BidRequests/BidRequests";
import Home from "./pages/Website/Home";
import PrivacyPolicy from "./pages/Website/legal/PrivacyPolicy";
import TermsOfService from "./pages/Website/legal/TermsOfService";
import SecurityPage from "./pages/Website/legal/Security";
import UseCasePage from "./pages/Website/UseCasePage";
import ContactUs from "./pages/Website/ContactUs";
import SubscriptionPage from "./pages/Subscription/SubscriptionPage";
import CampaignsPage from "./pages/Campaigns/CampaignsPage";
import SubscriptionDetail from "./components/subscription/SubscriptionDetail";
import ProvidedServices from "./pages/Dashboard/ProvidedServices";
import Industry from "./pages/Dashboard/Industry";
import AnalyticsPage from "./pages/Analytics/AnalyticsPage";
import InventoryItemsList from "./pages/Inventory/InventoryItemsList";
import InventoryItemDetail from "./pages/Inventory/InventoryItemDetail";
import LowStockView from "./pages/Inventory/LowStockView";
import InventoryReports from "./pages/Inventory/InventoryReports";
import InventoryAnalyticsDashboard from "./pages/Inventory/InventoryAnalyticsDashboard";
import InventorySettings from "./pages/Inventory/InventorySettings";
import StockOverview from "./pages/Inventory/stock/StockOverview";
import { Transfers as InventoryTransfers, StockTakes } from "./pages/Inventory/stock/StockControl";
import { Suppliers as InventorySuppliers, PurchaseOrders, GoodsReceipts } from "./pages/Inventory/stock/InvPurchasing";
import InventoryReorder from "./pages/Inventory/stock/Reorder";
import NewAppointment from "./components/Appointment/NewAppointment";
import ChannelsDashboard from "./pages/Channels/ChannelDashboard";
import channels from "./pages/Channels/Channels";
import Channels from "./pages/Channels/Channels";
import AdminSetupRevamp from "./pages/AdminSetupV2/AdminSetupRevamp";
import BrandingOffers from "./pages/BrandingOffers/BrandingOffers";
import AiAssistant from "./pages/AiAssistant/AiAssistant";
import LeadsList from "./pages/Leads/LeadsList";
import OperatingExpenses from "./pages/Finance/OperatingExpenses/OperatingExpenses";
import ExpensesGrid from "./pages/ExpenseManagement/ExpensesGrid";
import ExpenseJobsRedirect from "./pages/ExpenseManagement/ExpenseJobsRedirect";
import ExpenseManagementSettings from "./pages/ExpenseManagement/ExpenseManagementSettings";
import { hrRoutes } from "./pages/HR/HrRoutes";
import { platformRoutes } from "./pages/Platform/PlatformRoutes";
import SupplierLayout from "./pages/Supplier/SupplierLayout";
import SupplierHome from "./pages/Supplier/SupplierHome";
import SupplierBuyers from "./pages/Supplier/SupplierBuyers";
import SupplierCompany from "./pages/Supplier/SupplierCompany";
import SupplierRfqs from "./pages/Supplier/SupplierRfqs";
import SupplierRfqDetail from "./pages/Supplier/SupplierRfqDetail";
import SupplierMessages from "./pages/Supplier/SupplierMessages";
import SupplierOrders from "./pages/Supplier/SupplierOrders";
import SupplierOrderDetail from "./pages/Supplier/SupplierOrderDetail";
import SupplierInviteAccept from "./pages/Supplier/SupplierInviteAccept";
import StatutoryRates from "./pages/StatutoryRates/StatutoryRates";

// Initialize PubNub for vendor chat
const vendorPubnub = new PubNub({
  publishKey: pub_nub_publishKey,
  subscribeKey: pub_nub_subscribeKey,
  uuid: pub_nub_uuid
});

// Initialize PubNub for admin chat
const adminPubnub = new PubNub({
  publishKey: pub_nub_publishKey_admin,
  subscribeKey: pub_nub_subscribeKey_admin,
  uuid: pub_nub_uuid_admin
});

function App() {
  const { pathname } = useLocation();
  const isLoggedIn = !!localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const [notifications, setNotifications] = useState({});
  const [currentChannel, setCurrentChannel] = useState(null);
  const [isPortrait, setIsPortrait] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const lastFetchedTokenRef = useRef(null);

  // Industry drives which dashboard component a route renders (Dashboard vs
  // SportsDashboard vs NewDashboard1) — this must come from a fresh ezpMyProfile
  // fetch, not a cached localStorage snapshot. localStorage.userDetails is written
  // by several independent async fetches scattered across the app and can still
  // hold a previous session's (or no) industry right after login, which was
  // picking the wrong dashboard until something else happened to refresh it.
  const isClinicService = userData?.industry === 1;
  const isSportsService = userData?.industry === 7;

  const getUserProfile = async () => {
    try {
      const res = await apicall.get("ezpMyProfile");
      if (res.success) {
        setUserData(res.data[0]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // Runs after every render (cheap) but only actually fetches when the token
  // changes — this is what lets it self-correct right after a login/logout in
  // the same tab, since App itself doesn't unmount/remount for SPA navigation.
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && token !== lastFetchedTokenRef.current) {
      lastFetchedTokenRef.current = token;
      getUserProfile();
    } else if (!token && lastFetchedTokenRef.current) {
      lastFetchedTokenRef.current = null;
      setUserData(null);
    }
  });
  // useEffect(() => {
  //   const checkOrientation = () => {
  //     // Method 1: Use Screen Orientation API if available
  //     if (window.screen?.orientation?.type) {
  //       const orientation = window.screen.orientation.type;
  //       setIsPortrait(orientation.includes("portrait"));
  //     }
  //     // Method 2: Fallback to dimensions check
  //     else {
  //       setIsPortrait(window.innerHeight > window.innerWidth);
  //     }
  //   };

  //   // Initial check
  //   checkOrientation();

  //   // Add all possible event listeners
  //   window.addEventListener("resize", checkOrientation);
  //   window.addEventListener("orientationchange", checkOrientation);
  //   if (window.screen?.orientation) {
  //     window.screen.orientation.addEventListener("change", checkOrientation);
  //   }

  //   // Cleanup
  //   return () => {
  //     window.removeEventListener("resize", checkOrientation);
  //     window.removeEventListener("orientationchange", checkOrientation);
  //     if (window.screen?.orientation) {
  //       window.screen.orientation.removeEventListener(
  //         "change",
  //         checkOrientation
  //       );
  //     }
  //   };
  // }, []);

  // useEffect(() => {
  //   if (isPortrait) {
  //     alert("Please rotate to landscape for best experience");
  //     // Or show a custom UI message instead of alert
  //   }
  // }, [isPortrait]);

  useEffect(() => {
    if (isLoggedIn && userRole === admin_role_id.toString()) {
      const fetchChannels = async () => {
        try {
          const res = await apicall.get("admin_chatInfo");
          const channels = res.data.map((user) => user.pubnub_channel_id);
          adminPubnub.subscribe({ channels });

          adminPubnub.addListener({
            message: (event) => handleNewMessage(event)
          });

          const hasUnread = Object.values(notifications).some(
            (count) => count > 0
          );
          setHasUnreadMessages(hasUnread);
        } catch (error) {
          console.error("Error fetching channels:", error);
        }
      };

      fetchChannels();

      return () => {
        adminPubnub.unsubscribeAll();
      };
    }
  }, [isLoggedIn, userRole]);

  const handleNewMessage = (event) => {
    const { channel, publisher } = event;

    if (publisher === adminPubnub.getUUID()) {
      return;
    }

    if (!pathname.startsWith("/chat")) {
      toast.info("New message received");
    }

    setNotifications((prevNotifications) => {
      const updatedNotifications = {
        ...prevNotifications,
        [channel]: (prevNotifications[channel] || 0) + 1
      };

      setHasUnreadMessages(true);
      return updatedNotifications;
    });
  };

  const resetNotifications = (channel = null) => {
    setNotifications((prevNotifications) => {
      if (channel) {
        const { [channel]: _, ...remainingNotifications } = prevNotifications;
        setHasUnreadMessages(
          Object.values(remainingNotifications).some((count) => count > 0)
        );
        return remainingNotifications;
      } else {
        setHasUnreadMessages(false);
        return {};
      }
    });
  };

  useEffect(() => {
    if (pathname.startsWith("/chat") && currentChannel) {
      resetNotifications(currentChannel);
    }
  }, [pathname, currentChannel]);

  // Determine which PubNub instance to use based on user role
  const getPubNubInstance = () => {
    return userRole === admin_role_id.toString() ? adminPubnub : vendorPubnub;
  };

  return (
    <PrimeReactProvider>
      <PubNubProvider client={getPubNubInstance()}>
        <ImpersonationProvider>
          {/* <ToastContainer /> */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/use-cases/:slug" element={<UseCasePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/security" element={<SecurityPage />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/book-service/vendor/:id"
              element={<CustomerBooking />}
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="/access-denied" element={<AccessDenied />} />
            <Route path="/profile-setup" element={<ProfileSetup />} />
            {/* The link in a supplier invitation email: no login needed. */}
            <Route path="/supplier/invite/:token" element={<SupplierInviteAccept />} />

            {/* Vendor Routes - all 5 employee-access personas (Super Admin,
                Admin, Vendor, Crew, Support) can reach the shell; per-page
                and per-action restriction for Support/Crew is enforced
                inside components/nav config, not by subdividing this block,
                since some routes (e.g. /vendor_bookings) are shared between
                a persona's allowed and disallowed actions. */}
            <Route element={<ProtectedRoute allowedRoles={["1", "2", "3", "5", "6"]} />}>
              <Route element={<Layout />}>
                <Route
                  path="/dashboard"
                  element={
                    loading ? null : isClinicService ? (
                      <Dashboard />
                    ) : isSportsService ? (
                      <SportsDashboard />
                    ) : (
                      <NewDashboard1 />
                    )
                  }
                />
                <Route path="/setup" element={<Setup />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route
                  path="/dashboard/:date"
                  element={<DashboardDetailed />}
                />
                <Route path="/calendar" element={<CalendarPage />} />
                <Route path="/new_dashboard" element={<NewDashboard />} />
                <Route
                  path="/dashboard/view-profile"
                  element={<ViewProfile />}
                />
                <Route path="/doctors" element={<Doctors />} />
                <Route
                  path="/doctors/profile/:id"
                  element={<DoctorProfile />}
                />
                <Route path="/doctors/add" element={<AddDoctor />} />
                <Route path="/providers" element={<Providers />} />
                <Route path="/tasks" element={<MyTasks />} />
                <Route path="/new-appointment" element={<NewAppointment />} />
                <Route path="/industry" element={<Industry />} />
                <Route
                  path="/service-location"
                  element={<ProvidedServices />}
                />

                <Route
                  path="/providers/profile/:id"
                  element={<ProviderProfile />}
                />
                <Route path="/providers/add" element={<AddProviderGate />} />
                <Route
                  path="/doctors/add/availability"
                  element={<DoctorAvailability />}
                />
                <Route
                  path="/providers/add/availability"
                  element={<ProviderAvailability />}
                />
                <Route
                  path="/doctors/create-availability"
                  element={<CreateAvailability />}
                />
                <Route path="/supports" element={<Support />} />
                <Route path="/vendor_bookings" element={<Bookings />} />
                <Route path="/bid_requests" element={<BidRequests />} />
                <Route
                  path="/vendor_bookings/:group_id"
                  element={<Bookings />}
                />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/estimations" element={<Estimations />} />
                <Route path="/estimations/new" element={<EstimationForm />} />
                <Route path="/estimations/:id" element={<EstimationView />} />
                <Route path="/estimations/:id/edit" element={<EstimationForm />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/finance/operating-expenses" element={<OperatingExpenses />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/customers/company/:id" element={<CompanyProfile />} />
                <Route
                  path="/customers/profile/:id"
                  element={<CustomerProfile />}
                />
                <Route
                  path="/customers/profile/dependent/:id"
                  element={<CustomerProfile />}
                />
                <Route path="/add_items" element={<AddItems />} />
                <Route path="/add_offerings" element={<AddOfferings />} />
                <Route
                  path="/vendors/view-profile"
                  element={<VendorViewProfile />}
                />
                <Route path="/subscription" element={<SubscriptionPage />} />
                <Route
                  path="/subscription/:id"
                  element={<SubscriptionDetail />}
                />

                <Route path="/leads" element={<LeadsList />} />
              </Route>
            </Route>

            {/* Growth (Channels/Campaigns) - every persona except Crew. Split
                out from the main vendor block above so a Crew user typing
                these URLs directly hits AccessDenied, not just a hidden nav
                item (strict screen-view enforcement). */}
            <Route element={<ProtectedRoute allowedRoles={["1", "2", "3", "6"]} />}>
              <Route element={<Layout />}>
                <Route path="/channel" element={<Channels />} />
                <Route
                  path="/channel/dashboard"
                  element={<ChannelsDashboard />}
                />
                <Route path="/campaigns" element={<CampaignsPage />} />
              </Route>
            </Route>

            {/* AI Assistant settings - the vendor and their admins only (the API checks roles 2 and 3
                again); Support can use the assistant's drafts in Channels but not change how it works. */}
            <Route element={<ProtectedRoute allowedRoles={["2", "3"]} />}>
              <Route element={<Layout />}>
                <Route path="/ai-assistant" element={<AiAssistant />} />
              </Route>
            </Route>

            {/* Insights, Admin Setup & Employee Management - Admin/Vendor only
                (Super Admin, Admin, Vendor). Support and Crew don't get these
                menus, and this route split blocks direct URL access too, not
                just the hidden nav item (strict screen-view enforcement, same
                pattern as the Growth split above). */}
            <Route element={<ProtectedRoute allowedRoles={["1", "2", "3"]} />}>
              <Route element={<Layout />}>
                <Route path="/admin-setup" element={<AdminSetupRevamp />} />
                <Route path="/branding" element={<BrandingOffers />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/reports" element={<Reports />} />
                {/* The Teams screen is gone; people are managed under Employees. Old links and bookmarks land there. */}
                <Route path="/teams" element={<Navigate to="/hr" replace />} />
              </Route>
            </Route>

            {/* Inventory Management Module - every persona except Crew, the
                same people who get Growth (Super Admin, Admin, Vendor and
                Support); Crew hit a hard AccessDenied rather than just a
                hidden nav link. As with Growth, the plan_id === 3 rule is
                applied to the nav item only (sidebarNavConfig.js), not here.
                Reads are open to these roles in the API;
                writes are role 3 only and the item screens hide their write
                controls for everyone else. Booking "Parts Used" itself lives
                inside the existing /vendor_bookings route above and is usable
                by both roles 3 and 6, gated inline (see PartsUsedSection.jsx). */}
            <Route element={<ProtectedRoute allowedRoles={["1", "2", "3", "6"]} />}>
              <Route element={<Layout />}>
                <Route path="/inventory" element={<InventoryItemsList />} />
                <Route path="/inventory/:id" element={<InventoryItemDetail />} />
                <Route path="/inventory/low-stock" element={<LowStockView />} />
                <Route path="/inventory/reports" element={<InventoryReports />} />
                <Route path="/inventory/analytics" element={<InventoryAnalyticsDashboard />} />
                {/* inventory upgrade: warehouses, purchasing, stock control (the API checks who may do what) */}
                <Route path="/inventory/stock" element={<StockOverview />} />
                <Route path="/inventory/transfers" element={<InventoryTransfers />} />
                <Route path="/inventory/counts" element={<StockTakes />} />
                <Route path="/inventory/suppliers" element={<InventorySuppliers />} />
                <Route path="/inventory/purchase-orders" element={<PurchaseOrders />} />
                <Route path="/inventory/receipts" element={<GoodsReceipts />} />
                <Route path="/inventory/reorder" element={<InventoryReorder />} />
              </Route>
            </Route>

            {/* Inventory Settings - Admin/Vendor only: the page is nothing but
                write controls (costing method, markup, categories) and the API
                rejects every write from Support. */}
            <Route element={<ProtectedRoute allowedRoles={["1", "2", "3"]} />}>
              <Route element={<Layout />}>
                <Route path="/inventory/settings" element={<InventorySettings />} />
              </Route>
            </Route>

            {/* Expense Management - car service industry, Admin/Vendor only
                (Super Admin, Admin, Vendor). Support/Crew hit AccessDenied
                here; a non-car-service Admin/Vendor gets the graceful
                IndustryGate message inside the pages (ProtectedRoute only
                checks role), and the API enforces both server-side. */}
            <Route element={<ProtectedRoute allowedRoles={["1", "2", "3"]} />}>
              <Route element={<Layout />}>
                <Route path="/expense-management" element={<ExpenseJobsRedirect />} />
                <Route path="/expense-management/branch/:centerId" element={<ExpensesGrid />} />
                <Route path="/expense-management/settings" element={<ExpenseManagementSettings />} />
              </Route>
            </Route>

            {/* Human Resource (HR plan) - Admin, Vendor, Support and Crew. HrGate checks that
                HR is enabled for the vendor and, where a screen needs it, a permission set;
                the API enforces both again on every request. */}
            <Route element={<ProtectedRoute allowedRoles={["2", "3", "5", "6", "7"]} />}>
              <Route element={<Layout />}>{hrRoutes}</Route>
            </Route>

            {/* Finance and Dealership (switched on per vendor by the Super Admin) and the unified
                approvals inbox. ModuleGate checks the module and the person's permission sets;
                the API enforces both again on every request. */}
            <Route element={<ProtectedRoute allowedRoles={["2", "3", "5", "6", "7"]} />}>
              <Route element={<Layout />}>{platformRoutes}</Route>
            </Route>

            {/* Settings hub (new menu): links to the setup pages this person can already open, plus
                the menu preferences. Every staff role gets it; each linked page keeps its own guard. */}
            <Route element={<ProtectedRoute allowedRoles={["2", "3", "5", "6", "7"]} />}>
              <Route element={<Layout />}>
                <Route path="/settings" element={<SettingsHub />} />
              </Route>
            </Route>

            {/* Supplier portal (Procurement): an outside company's person (role 8) sees these and nothing else.
                The API refuses a supplier token everywhere else. */}
            <Route element={<ProtectedRoute allowedRoles={["8"]} />}>
              <Route element={<SupplierLayout />}>
                <Route path="/supplier" element={<SupplierHome />} />
                <Route path="/supplier/rfqs" element={<SupplierRfqs />} />
                <Route path="/supplier/rfqs/:id" element={<SupplierRfqDetail />} />
                <Route path="/supplier/orders" element={<SupplierOrders />} />
                <Route path="/supplier/orders/:id" element={<SupplierOrderDetail />} />
                <Route path="/supplier/messages" element={<SupplierMessages />} />
                <Route path="/supplier/buyers" element={<SupplierBuyers />} />
                <Route path="/supplier/company" element={<SupplierCompany />} />
              </Route>
            </Route>

            {/* Team User Routes (role 6 - access channel dashboard) */}
            {/* <Route element={<ProtectedRoute allowedRoles={["6"]} />}>
            <Route element={<Layout />}>
               <Route path="/setup" element={<Setup />} />
               <Route path="/analytics" element={<AnalyticsPage />} />
               <Route
                path="/dashboard"
                element={isClinicService ? <Dashboard /> : <NewDashboard1 />}
              />
              <Route path="/channel/dashboard" element={<ChannelsDashboard />} />
            </Route>
          </Route> */}

            {/* Admin Routes */}
            <Route element={<ProtectedRoute allowedRoles={["1"]} />}>
              <Route element={<Layout />}>
                <Route path="/users" element={<Users />} />
                <Route
                  path="/users/view-profile/:id"
                  element={<UserViewProfile />}
                />
                <Route
                  path="/users/add/availability"
                  element={<UserDoctorAvailability />}
                />
                <Route path="/statutory-rates" element={<StatutoryRates />} />
                <Route path="/vendors" element={<Vendors />} />
                <Route path="/vendors/add" element={<AddVendor />} />
                <Route path="/users/profile/:id" element={<DoctorProfile />} />
                <Route
                  path="/vendors/view-profile"
                  element={<VendorViewProfile />}
                />
                <Route
                  path="/vendors/view-profile/:id"
                  element={<Dashboard />}
                />
                <Route path="/vendors/edit/:id" element={<AddVendor />} />
                <Route path="/users/add" element={<AddUser />} />
                <Route path="/revenue" element={<Revenue />} />
                <Route
                  path="/chat"
                  element={
                    <ChatApp
                      resetNotifications={resetNotifications}
                      setCurrentChannel={setCurrentChannel}
                    />
                  }
                />
              </Route>
            </Route>

            {/* 404 Route */}
            <Route
              path="*"
              element={
                localStorage.getItem("token") ? (
                  <Navigate to="/404" replace />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </ImpersonationProvider>
      </PubNubProvider>
    </PrimeReactProvider>
  );
}

export default App;
